/**
 * Fussbereich in Ink Black.
 *
 * Airspace ist eine private Anwendung ohne Marketingseiten. Die vom
 * Design-Dokument vorgesehene vierspaltige Linkwueste waere hier leer -- statt
 * sie mit Platzhaltern zu fuellen, bleibt der Fuss auf das reduziert, was
 * tatsaechlich existiert. Flaeche, Typografie und die Trennlinie im
 * Bottom-Bereich folgen der Vorgabe.
 *
 * `on-ink` schaltet den Fokusring auf die helle Variante um.
 */
export function Footer(): React.ReactElement {
  const year = new Date().getFullYear();

  return (
    <footer className="footer on-ink">
      <div className="container">
        <h2>Dateien kommen an, wenn du es sagst.</h2>

        <div className="footer__bottom">
          <span>© {year} Airspace</span>
          <span>Selbst gehostet. Keine Weitergabe an Dritte.</span>
        </div>
      </div>
    </footer>
  );
}
